import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { CommonService } from "../../api/index";
import { SnackService } from "../../services/index";
import { NgForm } from "@angular/forms";
import { Users } from "../../interfaces/index";

@Component({
  selector: 'school-twofa-settings',
  templateUrl: './twofa-settings.component.html',
  styleUrls: ['./twofa-settings.component.scss']
})
export class TwofaSettingsComponent implements OnInit, OnDestroy {


  twofaFormValue = {} as Users;

  allComplete: boolean = false;
  @Input() formtype: string;
  @Output() accordionEvent = new EventEmitter();
  @Input() isExpand: any;
  @ViewChild("twofaForm", { static: false }) twofa_Form: NgForm;

  constructor(private route: Router,
    private _userService: CommonService,
    private _snackService: SnackService,
  ) { }

  ngOnInit(): void {
    
  }

  ngOnChanges(): void{
    if(this.isExpand == true){
      this.LoadData();
    }
  }

  
  ngOnDestroy(): void {
    this.accordionEvent.unsubscribe();
  }

  setAll(completed: boolean) {
    this.allComplete = completed;
  }


  LoadData() {

    this._userService.getLoginUserInfos().subscribe(
      result => {
        this.twofaFormValue.is_2fa = result.body.data.is_2fa;

      }, error => {
        this._snackService.openSnackBar("danger", "Failed to Load updated data..");
      });
  }

  onSubmit(): void {

    const saveData = { ...this.twofaFormValue };

    this._userService.savetwofa(saveData).subscribe(
      result => {
        this._snackService.openSnackBar("success", "2FA updated Successfully!...");

      }, error => {
        this._snackService.openSnackBar("danger", "Failed to update a 2FA..");
      });
  }


  cancelClick() {
    if (this.formtype == 'accordion') {

      this.accordionEvent.emit(false);
    }
    else {
      this.route.navigate([`/${this.formtype}`]);
    }
  }

}
